import api from "../services/api";

// Fetch all rates
export const fetchRates = async () => {
  try {
    const response = await api.get("/kilometer-package-management/rates");
    if (response.status === 200) {
      return { success: true, data: response.data.data };
    } else {
      console.warn("Unexpected response:", response);
      return { success: false, error: "Unexpected response from server" };
    }
  } catch (error) {
    console.error("Error fetching rates:", error.message || error);
    return { success: false, error: error.message || "Failed to fetch rates" };
  }
};

// Create a new rate
export const createRate = async (payload) => {
  try {
    const response = await api.post("/kilometer-package-management/rates/create", payload);
    if (response.status === 200) {
      return { success: true, data: response.data.data };
    } else {
      console.warn("Unexpected response:", response);
      return { success: false, error: "Unexpected response from server" };
    }
  } catch (error) {
    console.error("Error creating rate:", error.message || error);
    return { success: false, error: error.message || "Failed to create rate" };
  }
};

// Update an existing rate
export const updateRate = async (id, payload) => {
  try {
    const response = await api.put(`/kilometer-package-management/rates/${id}`, payload);
    if (response.status === 200) {
      return { success: true, data: response.data.data };
    } else {
      console.warn("Unexpected response:", response);
      return { success: false, error: "Unexpected response from server" };
    }
  } catch (error) {
    console.error("Error updating rate:", error.message || error);
    return { success: false, error: error.message || "Failed to update rate" };
  }
};

// Delete a rate
export const deleteRate = async (id) => {
  try {
    const response = await api.delete(`/kilometer-package-management/rates/${id}`);
    if (response.status === 200) {
      return { success: true, message: "Rate deleted successfully" };
    } else {
      console.warn("Unexpected response:", response);
      return { success: false, error: "Unexpected response from server" };
    }
  } catch (error) {
    console.error("Error deleting rate:", error.message || error);
    return { success: false, error: error.message || "Failed to delete rate" };
  }
};
